import React from "react";
import { translate } from "react-i18next";

import { Box, Text, Link } from "src/components";

import { DynamicForm } from "src/components/Form";

const answerCharacterMin = 3;
const answerCharacterMax = 150;

const fields = () => [
  {
    key: "answer",
    label: "Answer",
    required: true,
    inputProps: {
      autoComplete: "off",
    },
    constraints: {
      length: {
        minimum: answerCharacterMin,
        maximum: answerCharacterMax,
        tooShort: `must contain at least ${answerCharacterMin} characters`,
        tooLong: `cannot contain more than ${answerCharacterMax} characters`,
      },
    },
  },
];

const initialValues = {
  answer: process.env.CODE || "",
};

export const ChallengeQuestion = ({ t, ...props }) => (
  <Box>
    <Text fontSize={4} mb={2} color="orange">
      Please answer the following security question to continue:
    </Text>
    <Text fontSize={3} fontWeight="bold" color="orange" mb={2}>
      {props.loginState.challengeQuestion}
    </Text>
    <DynamicForm
      formKey="challenge-question"
      fields={fields}
      onSubmit={props.onSubmit}
      needsCaptcha={false}
      initialValues={initialValues}
    />
    <Link
      to="/app/login/forgotChallengeQuestions"
      color="green"
      mt={2}
      align="center"
      fontSize={2}
    >
      {t("olb.login.forgotLinkDescription")}
    </Link>
  </Box>
);

export default translate("translations")(ChallengeQuestion);



// WEBPACK FOOTER //
// ./src/banking/authentication/Login/steps/ChallengeQuestion.js